import { getTargetAudience } from 'lib/experiences/experienceUtils'
import { computeTopOfferListFiltersFromParams } from 'lib/experiences/computeTopOfferListFilters'
import { type ExperienceListFilters } from 'actions/ExperienceActions'
import { AnythingCategory, EXP_CATEGORY_AIRPORT_TRANSFER_ID, EXP_CATEGORY_LUX_PLUS_ID } from 'constants/experience'

const LIMIT_PER_PAGE = 9

export interface GenerateTopOfferFiltersParams {
  currencyCode: string
  geoCoords: { latitude?: number, longitude?: number }
  hotelOffer?: { id: string, experiencesCurated?: boolean }
  availability: { from?: string, to?: string }
  hasNoIncludedTransfer: boolean
  targetAudience?: App.ExperienceTargetAudience
}

export interface GenerateCategoryFiltersParams {
  categories: Array<App.ExperienceItemCategory>
  geoCoords: { latitude?: number, longitude?: number }
  startDate: string
  endDate: string
  currencyCode: string
  targetAudience: App.ExperienceTargetAudience
  oneClickTransferEnabled?: boolean
}

export function generateTopOfferFilters(params: GenerateTopOfferFiltersParams): Array<ExperienceListFilters> {
  const { currencyCode, geoCoords, hotelOffer, availability, hasNoIncludedTransfer, targetAudience } = params

  const topOfferLists = computeTopOfferListFiltersFromParams({
    currencyCode,
    geoCoords,
    hotelOffer,
    availability,
    hasNoIncludedTransfer,
    targetAudience,
  })

  return topOfferLists.map(l => ({ ...l.filters }))
}

export function generateCategoryFilters(params: GenerateCategoryFiltersParams): Array<ExperienceListFilters> {
  const { categories, geoCoords, startDate, endDate, currencyCode, targetAudience, oneClickTransferEnabled } = params

  if (!categories.length || !geoCoords.latitude || !geoCoords.longitude) return []

  const filteredCategories = categories
    .filter(cat => cat.level === 'parent' && cat.id !== AnythingCategory.id)
    .filter(cat => cat.id !== EXP_CATEGORY_LUX_PLUS_ID)

  return filteredCategories.map(cat => {
    const filters: ExperienceListFilters = {
      categoryCodes: [cat.id],
      latitude: geoCoords.latitude,
      longitude: geoCoords.longitude,
      limit: LIMIT_PER_PAGE,
      distanceRange: ['0KM', '50KM'],
      from: startDate,
      to: endDate,
      currencyCode,
      targetAudienceIn: [targetAudience],
    }

    if (oneClickTransferEnabled) {
      filters.categoryCodesNotIn = [EXP_CATEGORY_AIRPORT_TRANSFER_ID]
    }

    return filters
  })
}

export function calculateTargetAudience(occupancy: { adults?: number, children?: number }): App.ExperienceTargetAudience {
  return getTargetAudience(occupancy.adults ?? 1, occupancy.children ?? 0)
}
